import React, { useState} from "react";
import { connect } from "react-redux";

import {  makeStyles } from "@material-ui/core/styles";
import {  Card, CardActionArea, Dialog } from "@material-ui/core";

import { green } from "@material-ui/core/colors";
import DialpadIcon from '@mui/icons-material/Dialpad';


import Dtmf from "./Dtmf";

//store
import * as actions from "../../../../store/actions/actionIndex";

const useStyles = makeStyles((theme) => ({

	selectInput: {
		padding: 10,
		paddingInlineEnd: 25,
		"&:focus": {
			backgroundColor: "white",
		},
	},
	title: {
		display: "block",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		width: "100%",
		marginBottom: theme.spacing(1),
	},
	fab: {
		position: "absolute",
		//bottom: theme.spacing(2),
		top: theme.spacing(8),
		insetInlineEnd: theme.spacing(2),
	},
	fabGreen: {
		color: theme.palette.common.white,
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[600],
		},
	},
	AutoModeButton: {
		margin: "14px 0",
		textAlign: "end",
		display: "flex",
		justifyContent: "space-between",
	},
	ConferenceButton: {
		height: "36px",
		color: "#526FEB",
		"&:hover": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	callDialog: {
		//position:"fixed",
		insetInlineEnd: "50px",
	},
	DispositionTitle: {
		color: "white",
		backgroundColor: "#242a5a",
		fontSize: "15px",
		lineHeight: "18px",
		marginBottom: -1,
		padding: "16px 25px 16px 24px",
		minHeight: 40,
		"&$expanded": {
			minHeight: 40,
		},
	},
}));


function DtmfButton(props) {
	const classes = useStyles();

    const [dtmf, setDtmf] = useState(false);

    const handleDtmfOpen = () => {
		setDtmf(true);
	};

	const handleDtmfClose = () => {
		setDtmf(false);
	};

	// useEffect(() => {
	// 	if (open && props.agentState !== "FREE") {
	// 		setOpen(false);
	// 	}
	// }, [props.agentState, open, setOpen]);

	// useEffect(() => {
	// 	try {
	// 		setPreviewDialing(agentConf.previewDialing === "ENABLED" && agentConf.saveInPreview === "1" ? 1 : 0);
	// 	} catch (e) {}
	// }, [agentConf, setPreviewDialing]);

	return (
		<div>
        <Card className={classes.HoldandResumeButton} onClick={handleDtmfOpen} variant="contained" size="small"  style={{ height: "36px", color: "blue", backgroundColor: "aliceblue", border: "1px solid blue", textTransform: "capitalize" }}>
							<CardActionArea className={classes.AddCallActionArea} style={{marginTop:"0",display:"flex",padding:"5px 10px"}}  title="Send DTMF">
								<DialpadIcon />		
							</CardActionArea>
						</Card>
			<Dialog className="DialogConference dtmf-dialogue" style={{ borderRadius: "4px" }} open={dtmf} onClose={handleDtmfClose} aria-labelledby="customized-dialog-title">
					<Dtmf  handleDtmfClose= {handleDtmfClose}/>
			</Dialog>
			
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		agentId: state.agentData.agentId,
		agentConf: state.agentConfig.agentConf,
		agentMode: state.agentData.dialerType,
		autoMode: state.agentData.autoMode,
		agentState: state.agentData.agentState,
		modeError: state.agentMode.error,
		modeLoading: state.agentMode.loading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onModeChange: (agentId, mode, agentState) => dispatch(actions.modeChange(agentId, mode, agentState)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DtmfButton);
